import { CSSProperties, cx } from '@linaria/core';
import { ChangeEvent } from 'react';
import { palette } from '../styles/colors';
import "./Toggle.linaria.module.css!=!./Toggle?./Toggle.linaria.module.css?css=H4sIAAAAAAAAA23MQQ6CMBBA0T2ncImLNtaokHIRds1QCtYCQ6ZFwIa7m2iiiXH38xePQ+iVGNb6lpESzsIkHvzP2/GAbdsZ5mcb9DVWoF1LOA0109ghyTtQyth374steUNZ7pdmVmKyufH0A0lZmQbJxEAw+Aapl6/qIJgyPV7G5QO5kxKjXZfZRRxB27DKAz8XW/IE715s7cQAAAA="
const stylesChecked = "atm_1nydj7r_1kiau1z atm_178sxfw_1ui8esr";
const stylesDisabled = "atm_k4_1piyxwk";
interface IToggle {
  activeColor?: string;
  className?: string;
  checked: boolean;
  'data-testid'?: string;
  disabled?: boolean;
  onToggle(event: ChangeEvent<HTMLInputElement>): void;
  name?: string;
  title?: string;
}
export const Toggle = (props: IToggle) => {
  const {
    activeColor = palette.greenMFC,
    disabled = false,
    checked = false,
    className,
    'data-testid': testId,
    onToggle,
    name,
    title
  } = props;
  const dataTestId = testId ?? (name ? `Toggle__${name}` : undefined);
  return <div data-testid={dataTestId} title={title} className={cx(checked && stylesChecked, disabled && stylesDisabled, className)} style={{
    '--background': activeColor
  } as CSSProperties}>
            <label className={'toggle'}>
                <input checked={checked} data-checked={checked} disabled={disabled} name={name} onChange={onToggle} type="checkbox" value={checked.toString()} className={'toggle-checkbox'} />
                <div className={cx('toggle-switch')} />
                {/* <span className="toggle-label"></span> */}
            </label>
        </div>;
};